export default __webpack_public_path__ + "static/media/instagram.a7cb136a.svg";